import React from "react";
import PropTypes from "prop-types";
import IkTable from "@Components/IkTable";
import styles from "./styles.module.css";
import { columnsByRoute } from "./staticData";

const Table = ({ filteredItems, handleButtom, filteredCount, handlerData, filteredPrintData, checkAlllData, route }) => {
	const columns = columnsByRoute[route] || [];

	return (
		<div className={styles.tableContainer}>
			<IkTable
				data={filteredItems}
				columns={columns}
				handlerTable={handleButtom}
				totalRows={filteredCount}
				dataHandler={handlerData}
				filteredPrintData={filteredPrintData}
				searcher={{
					searchable: true,
					searchPosition: "flex-start",
					searchDisabled: false,
					filterButton: false,
					width: "40rem",
				}}
				print={{
					visiblePDF: true,
					visibleExcel: false,
					printable: true,
				}}
				topButtons={[
					{
						content: "Refrescar",
						icon: "refresh",
						className: styles.refreshButton,
						onClick: () => {
							return handlerData({});
						},
					},
				]}
				checkAllData={checkAlllData}
				defaultParams={{ rows: 20, page: 1 }}
			/>
		</div>
	);
};

Table.propTypes = {
	filteredItems: PropTypes.array,
	handleButtom: PropTypes.func,
	filteredCount: PropTypes.number,
	handlerData: PropTypes.func,
	filteredPrintData: PropTypes.array,
	checkAlllData: PropTypes.array,
	route: PropTypes.string,
};

export default Table;
